// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// Котировка считается Invalid, если у нее Bid == double.Nan или Ask == double.NaN
// Enum используется для того чтобы мы понимали, какую котировку необходимо брать в настоящий момент
// Last - берем любую последнюю котировку, неважно, валидная она или нет
// Valid - берем последнюю валиднуюю котировку (Bid > 0 и Ask > 0 )
// Invalid - последняя невалидная котировка (Bid == double.NaN или Ask == double.NaN)
export var QuoteValid;
(function (QuoteValid) {
    QuoteValid[QuoteValid["Last"] = 0] = "Last";
    QuoteValid[QuoteValid["Valid"] = 1] = "Valid";
    QuoteValid[QuoteValid["Invalid"] = 2] = "Invalid";
    QuoteValid[QuoteValid["ValidForMarket"] = 3] = "ValidForMarket";
})(QuoteValid || (QuoteValid = {}));
